import React from 'react';

import Currency from '@prisjakt/ui-currency';

import * as S from './styles';

import { Product } from '../../../../types';

type Props = {
  name: Product['name'];
  image: Product['media']['first'];
  rating: Product['userReviewSummary']['rating'];
  ratingCount: Product['userReviewSummary']['rating'];
  price: Product['priceSummary']['regular'];
  pathName: Product['pathName'];
};

const ReviewProduct = ({
  name,
  image,
  rating,
  ratingCount,
  price,
  pathName,
}: Props) => {
  return (
    <S.Product to={pathName}>
      {image && (
        <S.ProductImage>
          <img width={40} src={image} alt="" />
        </S.ProductImage>
      )}

      <S.ProductName>{name}</S.ProductName>

      <S.ProductRating
        rate={rating}
        singleStar
        showRate
        showCounter
        count={ratingCount}
        countTranslation={{
          domain: 'product',
          key: 'product-card.n-ratings',
        }}
      />

      {price ? (
        <S.Currency>
          <Currency price={price} />
        </S.Currency>
      ) : null}
    </S.Product>
  );
};

export default ReviewProduct;
